/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import * as yup from "yup";

const requiredWhenBusiness = {
    is: true,
    then: yup => yup.required(),
};

const requiredOnPackage = {
    is: true,
    then: yup => yup.required(),
};

let EMAIL_REGX =
    /^(([^<>()\[\]\\.,;:\s@"]+(.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}])|(([a-zA-Z-0-9]+.)+[a-zA-Z]{2,}))$/;

export const ArboAddressMandatorySchema = yup.object().shape({
    cin: yup.string(),
    city: yup.string().required("Stadt muss ausgefüllt werden"),
    company_name: yup.string().when("company_type", requiredWhenBusiness),
    company_type: yup.boolean(),
    email: yup.string().matches(EMAIL_REGX, "Ugültiges Email-Format").required(),
    first_name: yup.string().required("Der Vorname muss ausgefüllt werden"),
    is_newsletter_enabled: yup.bool(),
    last_name: yup.string().required("Der Nachname muss ausgefüllt werden"),
    notification_method: yup.string().oneOf(["email", "phone"]),
    phone: yup.string().min(12).required(),
    postal_code: yup.string().required("Postleitzahl muss ausgefüllt werden"),
    required_on_package: yup.boolean().required(),
    reservation_note: yup.string(),
    street_address: yup.string().required("Adresse muss ausgefüllt werden"),
    tos: yup.bool().oneOf([true], "Feld muss angekreuzt werden"),
    tos_verifier: yup.bool().oneOf([true], "Feld muss angekreuzt werden"),
});

// export const ArboSellerAddressMandatorySchema = yup.object().shape({
//     cin: yup.string(),
//     city: yup.string().required("Stadt muss ausgefüllt werden"),
//     company_name: yup.string().when("company_type", requiredWhenBusiness),
//     company_type: yup.boolean(),
//     email: yup.string().matches(EMAIL_REGX, "Ugültiges Email-Format").required(),
//     first_name: yup.string().required("Der Vorname muss ausgefüllt werden"),
//     is_newsletter_enabled: yup.bool(),
//     last_name: yup.string().required("Der Nachname muss ausgefüllt werden"),
//     notification_method: yup.string().oneOf(["email", "phone"]),
//     phone: yup.string().min(12).required(),
//     postal_code: yup.string().required("Postleitzahl muss ausgefüllt werden"),
//     reservation_note: yup.string(),
//     street_address: yup.string().required("Adresse muss ausgefüllt werden"),
//     tos: yup.bool().oneOf([true], "Feld muss angekreuzt werden"),
//     tos_verifier: yup.bool().oneOf([true], "Feld muss angekreuzt werden"),
// });

export const ArboSellerAddressMandatorySchemaBasicRequired = yup.object().shape({
    cin: yup.string().notRequired(),
    city: yup.string(),
    company_name: yup.string(),
    company_type: yup.boolean(),
    email: yup.string(),
    first_name: yup.string().required("Der Vorname muss ausgefüllt werden"),
    // is_newsletter_enabled: yup.bool(),
    last_name: yup.string().required("Der Nachname muss ausgefüllt werden"),
    notification_method: yup.string(),
    phone: yup.string(),
    postal_code: yup.string(),
    reservation_note: yup.string(),
    street_address: yup.string(),
    // tos: yup.bool(),
    // tos_verifier: yup.bool(),
});
